import React, { useCallback, useEffect, useState } from 'react';

import { FaFacebook } from 'react-icons/fa';

import { StyledFacebookSignIn } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('facebook-sign-in');

const FacebookSignIn = ({ onSuccess, onError, variant = 'full' }) => {
  const [sdkError, setSdkError] = useState(null);

  useEffect(() => {
    const appId = import.meta.env.VITE_FACEBOOK_APP_ID;

    if (!appId) {
      console.error('[FacebookSignIn] VITE_FACEBOOK_APP_ID is not configured');
      setSdkError('Facebook App ID not configured');

      return;
    }

    // Check if SDK is already loaded and initialized
    if (window.FB) {
      return;
    }

    // Check if script is already in DOM
    if (document.getElementById('facebook-jssdk')) {
      return;
    }

    // Load the SDK script
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';

    script.onerror = () => {
      console.error('[FacebookSignIn] Failed to load Facebook SDK script');
      setSdkError('Failed to load Facebook SDK');
    };

    document.body.appendChild(script);

    return () => {
      // Cleanup not needed for SDK script
    };
  }, []);

  const handleClick = useCallback(() => {
    if (sdkError) {
      console.error('[FacebookSignIn] SDK Error:', sdkError);
      onError?.({ error: sdkError });

      return;
    }

    if (!window.FB) {
      console.error('[FacebookSignIn] Facebook SDK not available');
      onError?.({ error: 'Facebook SDK not loaded. Please try again in a moment.' });

      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse) {
          onSuccess?.({
            accessToken: response.authResponse.accessToken,
            userID: response.authResponse.userID,
          });
        } else if (response.status === 'not_authorized') {
          onError?.({ error: 'Please authorize the app to continue.' });
        } else {
          onError?.({ error: 'Facebook login was cancelled.' });
        }
      },
      { scope: 'email,public_profile' },
    );
  }, [sdkError, onSuccess, onError]);

  if (variant === 'icon') {
    return (
      <StyledFacebookSignIn>
        <button
          className={b('circle')}
          onClick={handleClick}
          type="button"
          disabled={!!sdkError}
          title="Continue with Facebook"
        >
          <FaFacebook className={b('circle-icon')} />
        </button>
      </StyledFacebookSignIn>
    );
  }

  return (
    <StyledFacebookSignIn>
      <button className={b()} onClick={handleClick} type="button" disabled={!!sdkError}>
        <FaFacebook className={b('icon')} />
        <span className={b('text')}>Continue with Facebook</span>
      </button>
    </StyledFacebookSignIn>
  );
};

export default FacebookSignIn;
